module.exports = __webpack_public_path__ + "static/media/md-add-circle.85393ba8.svg";